import { BaseModel } from '../../actions/framework';
import { ModelResource } from '../../actions/framework/types';
import { ManifestMeta } from '@cotera/client/app/etc/api/typed-client';

export class ManifestModel extends BaseModel {
  constructor(readonly manifestInfo: ManifestMeta) {
    super('manifest');
  }

  resources(): ModelResource[] {
    return [];
  }
}
